import { useEffect } from 'react'
import { useToastStore, type Toast } from '../toast/useToastStore'

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none max-w-sm w-[22rem]">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  )
}

function ToastItem({ toast }: { toast: Toast }) {
  const dismiss = useToastStore((s) => s.dismiss)

  useEffect(() => {
    if (toast.durationMs == null) return
    const handle = window.setTimeout(() => dismiss(toast.id), toast.durationMs)
    return () => window.clearTimeout(handle)
  }, [toast.id, toast.durationMs, dismiss])

  const styles =
    toast.kind === 'success'
      ? 'text-emerald-300 bg-emerald-950/80 border-emerald-800'
      : toast.kind === 'error'
        ? 'text-red-300 bg-red-950/80 border-red-800'
        : 'text-zinc-200 bg-zinc-900/90 border-zinc-700'

  return (
    <div
      role={toast.kind === 'error' ? 'alert' : 'status'}
      className={`pointer-events-auto rounded border shadow-lg backdrop-blur-sm px-3 py-2.5 text-sm flex items-start gap-2 animate-[toast-in_180ms_ease-out] ${styles}`}
    >
      <div className="flex-1 min-w-0">
        {toast.title && <div className="font-semibold text-[13px] mb-0.5">{toast.title}</div>}
        <div className="whitespace-pre-wrap break-words font-mono text-[12.5px] leading-snug">
          {toast.message}
        </div>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => dismiss(toast.id)}
        className="shrink-0 opacity-60 hover:opacity-100 text-base leading-none px-1 -mr-1"
      >
        ×
      </button>
    </div>
  )
}
